<template>
    <van-popup
        v-model="open"
        position="bottom"
        safe-area-inset-bottom
        @close="onClose"
    >
        <van-datetime-picker
            v-model="currentDate"
            :type="type"
            :filter="dateTimeFilter"
            :formatter="dateTimeFormatter"
        >
            <template #default>
                <div class="date-picker-title">{{ dateFormatting(currentDate) }}</div>
            </template>
        </van-datetime-picker>
        <div class="footer">
            <van-button
                type="warning"
                plain
                @click="handleCancel"
            >取消</van-button>
            <van-button
                type="warning"
                @click="handleConfirm"
            >确定</van-button>
        </div>
    </van-popup>
</template>

<script>
import { parseTime } from "@/utils/index.js";
import { Popup , DatetimePicker , Button } from "vant";
export default {
    components:{
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
        [Button.name]: Button,
    },
    data(){
        return {
            open: false,
            currentDate: new Date(),
            type: "datetime",
            promiseResolve: null,
            promiseReject: null,
            initialData: {}
        }
    },
    created(){
        this.initialData = this.deepClone(this.$data);
    },
    methods: {
        init(options){
            return new Promise((resolve,reject) => {
                this.reset();
                this.promiseResolve = resolve;
                this.promiseReject = reject;
                // 需求：只显示整5分钟，且默认显示当前时间的整5分钟
                this.currentDate = new Date();
                if(options) {
                    Object.keys(options).map(key => {
                        if(!this.$data.hasOwnProperty(key)) return;
                        this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(options[key])) 
                        ? this.deepClone(options[key]) : options[key];
                    })
                }
                this.open = true;  
            })
        },
        handleConfirm(){
            this.promiseReject = null;
            this.promiseResolve && this.promiseResolve(this.currentDate);
            this.open = false;
        },
        handleCancel(){
            this.open = false;
        },
        onClose(){
            this.promiseReject && this.promiseReject("cancel");
        },
        dateTimeFilter(type,options){
            if (type === 'minute') {
                return options.filter((option) => option % 5 === 0);
            }
            return options;
        },
        dateTimeFormatter(type,val){
            if (type === 'year') {
                return val + '年';
            }
            if (type === 'month') {
                return val + '月';
            }
            if (type === 'day') {
                return val + '日';
            }
            return val;
        },
        dateFormatting(date){
            return `${parseTime(date,"{y}年{m}月{d}日")} ${this.getDayOfWeek(date)}`
        },
        getDayOfWeek(date) {
            const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            const dayIndex = date.getDay();
            return days[dayIndex];
        },
        reset(){
            Object.keys(this.initialData).map(key => {
                if(key === "initialData") return false;
                this[key] = ["[object Object]","[object Array]"].includes(Object.prototype.toString.call(this.initialData[key])) 
                ? this.deepClone(this.initialData[key]) : this.initialData[key];
            })
        }, 
    }
}
</script>

<style scoped lang="scss">
    .date-picker-title {
        font-size: 16px;
        color: #393939;
        text-align: center;
        flex: 1;
    }
    .footer {
        padding-top: 40px;
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 8px);
        padding-bottom: calc(env(safe-area-inset-bottom) + 8px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-button {
            min-width: 122px;
            height: 38px;
            border-radius: 4px;
            overflow: hidden;
            font-size: 16px;
        }
        .van-button--warning {
            background-color: #EC892E;
            border-color: #EC892E;
            color: #FFF;
        }
        .van-button--plain {
            background-color: #FFF;
            border-color: #EC892E;
            color: #EC892E;
        }
    }
    ::v-deep .van-picker-column__item--selected {
        color: #EC892E;
    }
</style>